import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router";

import { ErrorBox, Spinner } from "@/components/Spinner";

/**
 * La destination portée par le `state` de la requête de connexion (le step-up
 * y met `/security`). N'accepte qu'un chemin interne : jamais une URL complète,
 * ni un `//hôte`, ni une barre oblique inverse (`/\hôte`, que les navigateurs
 * lisent comme `//hôte` : l'avis react-router GHSA-wrjc-x8rr-h8h6).
 */
function safeReturnTo(state: unknown): string {
  const returnTo = (state as { returnTo?: unknown } | null | undefined)?.returnTo;
  return typeof returnTo === "string" &&
    returnTo.startsWith("/") &&
    !returnTo.startsWith("//") &&
    !returnTo.includes("\\")
    ? returnTo
    : "/";
}

export function AuthCallback() {
  const auth = useAuth();
  if (auth.isLoading) return <Spinner label="Completing sign-in…" />;
  if (auth.error) return <ErrorBox error={auth.error} />;
  if (auth.isAuthenticated) return <Navigate to={safeReturnTo(auth.user?.state)} replace />;
  return <Spinner label="Redirecting…" />;
}
